export {default as configureStore} from './store';